import { useMutation } from '@tanstack/react-query';
import { APITypes } from '../../primary-record-types';
import { Platform } from 'react-native';
import { appAPI } from '../../utils/api';
import urls from '../../utils/urls';
import useUser from './useUser';
import { useEffect } from 'react';

const registeredUsers = new Set<string>();

export const useRegisterUserPlatform = () => {
    const { user } = useUser({});
    const registerUserPlatformMutation = useMutation({
        mutationFn: () => {
            const body: APITypes.userService.UserPlatformRequest = {
                platform: Platform.OS,
            };
            return appAPI.post(urls.api.users.platform, {
                body,
            });
        },
    });

    useEffect(() => {
        if (user === 'loading' || !user.userId) return;

        if (registeredUsers.has(user.userId)) return;

        registerUserPlatformMutation.mutate();
        registeredUsers.add(user.userId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);
};
